import z from "zod";
import { PageableRequestSchema, UserInfoResponseSchema } from "./shared";

export const SearchCompanyUsersResponseSchema = z.object({
  items: z.array(UserInfoResponseSchema),
  totalPages: z.number(),
  totalElements: z.number(),
  pageSize: z.number(),
  next: z.string().nullable().optional(),
  previous: z.string().nullable().optional(),
});

export type SearchCompanyUsersResponse = z.infer<
  typeof SearchCompanyUsersResponseSchema
>;

export const UpdateCompanyInfoRequestSchema = z.object({
  companyId: z.number(),
  companyAdminId: z.number(),
  companyName: z.string(),
  ceoName: z.string().nullable().optional(),
  logoUrl: z.string().nullable().optional(),
  faviconUrl: z.string().nullable().optional(),
  domain: z.string().nullable().optional(),
  /** 쇼핑몰 검색 노출 활성화 여부. 생략하면 기존 값 유지 */
  searchEngineIndexingEnabled: z.boolean().optional(),
  companySealImageUrl: z.string().nullable().optional(),
  companySealImageFile: z.any().nullable().optional(),
  phone: z.string().nullable().optional(),
  secondaryContactType: z.string().nullable().optional(),
  secondaryContact: z.string().nullable().optional(),
  zipCode: z.string().nullable().optional(),
  address: z.string().nullable().optional(),
  addressDetail: z.string().nullable().optional(),
  ecommerceBizNumber: z.string().nullable().optional(),
  businessNumber: z.string().nullable().optional(),
  businessType: z.string().nullable().optional(),
  businessCategory: z.string().nullable().optional(),
  businessRegistrationFileUrl: z.string().nullable().optional(),
  /** 쇼핑몰 푸터에 한 줄 더 노출하는 추가 사업자 정보 (표시 전용 자유 텍스트). 줄바꿈으로 여러 줄 가능 */
  additionalBusinessInfo: z.string().nullable().optional(),
  homeTaxKey: z.string().nullable().optional(),
  tossPayKey: z.string().nullable().optional(),
  tossSecretKey: z.string().nullable().optional(),
  channelTalkKey: z.string().nullable().optional(),
  logoFile: z.any().optional(),
  faviconFile: z.any().optional(),
  businessHours: z.string().nullable().optional(),
  lunchBreak: z.string().nullable().optional(),
  businessHoursNotice: z.string().nullable().optional(),
  businessRegistrationFile: z.any().nullable().optional(),
});

export type UpdateCompanyInfoRequest = z.infer<
  typeof UpdateCompanyInfoRequestSchema
>;

export const UserRoleSchema = z.enum([
  "ADMIN",
  "COMPANY_ADMIN",
  "COMPANY_MANAGER",
  "USER",
]);

export const GetCompanyInfoRequestSchema = z.object({
  companyId: z.number(),
});

export type GetCompanyInfoRequest = z.infer<typeof GetCompanyInfoRequestSchema>;

export const UpdateUserRoleRequestSchema = z.object({
  companyId: z.number(),
  targetUserIds: z.array(z.number()),
  targetRequestRole: UserRoleSchema,
  departmentId: z.number().nullable().optional(),
  newDepartmentName: z.string().nullable().optional(),
});

export type UpdateUserRoleRequest = z.infer<typeof UpdateUserRoleRequestSchema>;

/** 회사 소속 쇼핑몰 회원 탈퇴 처리 요청 (되돌릴 수 없음) */
export const WithdrawCompanyUserRequestSchema = z.object({
  companyId: z.number(),
  userId: z.number(),
});

export type WithdrawCompanyUserRequest = z.infer<
  typeof WithdrawCompanyUserRequestSchema
>;

export const SearchCompanyUsersRequestSchema = z.object({
  companyId: z.number(),
  pageable: PageableRequestSchema,
  keyword: z.string().nullable().optional(),
  role: z
    .enum(["ADMIN", "COMPANY_ADMIN", "COMPANY_MANAGER", "USER"])
    .nullable()
    .optional(),
});

export type SearchCompanyUsersRequest = z.infer<
  typeof SearchCompanyUsersRequestSchema
>;

export const RealtimeGraphVertexSchema = z.object({
  date: z.string(),
  equipmentOperationCount: z.number(),
  paymentCount: z.number(),
  paymentAmount: z.number(),
});

export type RealtimeGraphVertex = z.infer<typeof RealtimeGraphVertexSchema>;
